import React, { useState, useRef, useLayoutEffect } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const PieChartBilling = ({ delivered = 60, pending = 25, expired = 15, loading = false }) => {

  const total = delivered + pending;
  let deliveredPercent = 0;
  let pendingPercent = 0;
  if (total > 0) {
    deliveredPercent = parseFloat(((delivered / total) * 100).toFixed(2));
    pendingPercent = parseFloat(((pending / total) * 100).toFixed(2));
  }
  const expiredPercent = parseFloat(((expired / total) * 100).toFixed(2));
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const data = [
    {
      name: 'Facturado',
      value: delivered,
      color: '#769B40',
      percent: deliveredPercent,
      dollar: Math.round(400 * (delivered / 60)) // $400 para el valor base de 60
    },
    {
      name: 'Pendiente de facturación',
      value: pending,
      color: '#FFC000',
      percent: pendingPercent,
      dollar: Math.round(250 * (pending / 25)) // $250 para el valor base de 25
    },
    /* {
      name: 'Pendiente de devolución (Nota de crédito)',
      value: expired,
      color: '#58B6E5',
      percent: expiredPercent,
      dollar: Math.round(150 * (expired / 15)) // $150 para el valor base de 15
    } */
  ];

  function HoverLabel({ x, y, label }) {
    const textRef = useRef(null);

    const [size, setSize] = useState({ w: 0, h: 0 });

    useLayoutEffect(() => {
      if (textRef.current) {
        const { width, height } = textRef.current.getBBox();
        setSize({ w: width, h: height });
      }
    }, [label]);

    const paddingX = 6;
    const paddingY = 4;
    const rectWidth = size.w + paddingX * 2;
    const rectHeight = size.h + paddingY * 2;
    const offsetY = rectHeight / 2 + 12;

    return (
      <g transform={`translate(${x}, ${y + offsetY})`}>
        <rect
          x={-rectWidth / 2}
          y={-rectHeight / 2}
          width={rectWidth}
          height={rectHeight}
          rx={rectHeight / 2}
          fill="rgba(0, 0, 0, 0.7)"
          stroke="white"
          strokeWidth={1}
        />
        <text
          ref={textRef}
          x={0}
          y={0}
          fill="white"
          stroke="black"
          strokeWidth={0.5}
          paintOrder="stroke"
          textAnchor="middle"
          dominantBaseline="middle"
          className="text-[12px] font-itcmedium pointer-events-none"
        >
          {label}
        </text>
      </g>
    );
  }

  const renderCustomizedLabel = ({
    cx, cy, midAngle, innerRadius, outerRadius, percent, index
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const isHovered = hoveredIndex === index;

    return (
      <g style={{ userSelect: 'none', pointerEvents: 'none' }}>
        <text
          x={x}
          y={y}
          fill="white"
          textAnchor="middle"
          dominantBaseline="central"
          className="text-[12px] font-itcbold pointer-events-none"
        >
          {`${data[index].percent}%`}
        </text>
        {isHovered && (
          <HoverLabel
            x={x}
            y={y}
            label={`$${data[index].value}`}
          />
        )}
      </g>
    );
  };

  if (loading) {
    return (
      <div className="w-full h-[250px] flex items-center justify-center bg-white rounded-[10px] shadow-md">
        <div className="w-6 h-6 border-2 border-gray-300 rounded-full animate-spin border-t-transparent" />
        <p className="ml-3 text-gray-500">Cargando...</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col justify-between gap-3 h-full w-full p-4 bg-white rounded-[10px] shadow-lg">
      <h2 className="text-lg text-center text-blue font-itcbold">Facturación</h2>
      <div className="relative" style={{ height: '220px' }}>
        {total > 0 ?
          (<ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius="40%"
                outerRadius="85%"
                paddingAngle={0}
                dataKey="value"
                labelLine={false}
                label={renderCustomizedLabel}
                onMouseEnter={(_, index) => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.color}
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          ) : (
            <div className="flex items-center justify-center h-full">
              <div className="text-center text-gray-400">
                <p className="text-lg font-semibold">No hay datos disponibles</p>
              </div>
            </div>
          )}
      </div>
      <div className="flex flex-col justify-center gap-3">
        {data.map((item, index) => (
          <div key={`legend-${index}`} className="flex items-center justify-between">
            <div className="flex items-center">
              <div
                className="w-3 h-3 mr-2 rounded-full"
                style={{ backgroundColor: item.color }}
              />
              <span className="text-xs font-itcmedium text-[#111928]">{item.name}</span>
            </div>
            <p className="font-itcbold text-[#404040] text-[12px]">{item.percent}%</p>
          </div>
        ))}
      </div>
      {/* <div className='flex justify-center'>
        <button className='text-white font-itcmedium w-[80%] bg-green rounded-[5px] p-[10px]'>Ver todos</button>
      </div> */}
    </div>
  );
};

export default PieChartBilling;